<template>
	<sf-modal-layout size="xl" :title="getMessage_('SWCC000310')" ref="modal" :show="show_" :closeModal="closeModal">
		<!-- Plant Start -->
		<el-row :gutter="30">
			<el-col :span="8">
				<sf-select-group
					:label="getMessage_('SWCC000247')"
					:labelSpan="10"
					labelPosition="left"
					:inputValue="selectedRow.plantCd"
					:options="plants_"
					:onChange="value => onChange({ key: 'plantCd', value })"
				/>
			</el-col>
		</el-row>
		<!-- Plant End -->

		<!-- Process ID Start -->
		<el-row :gutter="30">
			<el-col :span="8">
				<sf-input-group
					:label="getMessage_('SWCC000286')"
					:labelSpan="10"
					labelPosition="left"
					:inputValue="selectedRow.procId"
					:onChange="value => onChange({ key: 'procId', value })"
					:disabled="disabled"
				/>
			</el-col>
		</el-row>
		<!-- Process ID End -->

		<!-- Process Name Start -->
		<el-row :gutter="30">
			<el-col :span="8">
				<sf-input-group
					:label="getMessage_('SWCC000287')"
					:labelSpan="10"
					labelPosition="left"
					:inputValue="selectedRow.procName"
					:onChange="value => onChange({ key: 'procName', value })"
				/>
			</el-col>
		</el-row>
		<!-- Process Name End -->

		<!-- Service & Process Type Start -->
		<el-row :gutter="30">
			<el-col :span="8">
				<sf-select-group
					:label="getMessage_('SWCC000250')"
					:labelSpan="10"
					labelPosition="left"
					:inputValue="selectedRow.serviceKind"
					:options="serviceKinds_.filter(serviceKind => serviceKind.label !== 'ALL')"
					:onChange="value => onChange({ key: 'serviceKind', value })"
				/>
			</el-col>
			<el-col :span="8">
				<sf-select-group
					:label="getMessage_('SWCC000288')"
					:labelSpan="10"
					labelPosition="left"
					:inputValue="selectedRow.procType"
					:options="procTypes_.filter(option => option.label !== 'ALL')"
					:onChange="value => onChange({ key: 'procType', value })"
				/>
			</el-col>
		</el-row>
		<!-- Service & Process Type End -->

		<!-- Input Device Start -->
		<!-- <el-row :gutter="30">
			<el-col :span="8">
				<sf-select-group
					:label="getMessage_('SWCC000289')"
					:labelSpan="10"
					labelPosition="left"
					:inputValue="selectedRow.inputDeviceId"
					:options="inDevs_"
					:onChange="value => onChange({ key: 'inputDeviceId', value })"
				/>
			</el-col>
		</el-row> -->
		<!-- Input Device End -->

		<!-- Output Device Start -->
		<!-- <el-row :gutter="30">
			<el-col :span="8">
				<sf-select-group
					:label="getMessage_('SWCC000290')"
					:labelSpan="10"
					labelPosition="left"
					:inputValue="selectedRow.outputDeviceId"
					:options="outDevs_"
					:onChange="value => onChange({ key: 'outputDeviceId', value })"
				/>
			</el-col>
		</el-row> -->
		<!-- Output Device End -->

		<!-- Process Param Start -->
		<el-row :gutter="30">
			<el-col :span="8">
				<sf-input-group
					:label="getMessage_('SWCC000291')"
					:labelSpan="10"
					labelPosition="left"
					:inputValue="selectedRow.procPara"
					:onChange="value => onChange({ key: 'procPara', value })"
				/>
			</el-col>
		</el-row>
		<!-- Process Param End -->

		<!-- DQWait Time & Reg Read Time & Status Update Time Start -->
		<el-row :gutter="30" style="display: flex; align-items: center">
			<el-col :span="8">
				<sf-group-wrapper class="checkbox-form" :label="getMessage_('SWCC000292')" labelPosition="left" :gutter="30" :labelSpan="15">
					<sf-input-group :inputValue="selectedRow.dqWaitTime" :onChange="value => onChange({ key: 'dqWaitTime', value })" />
					<!-- :elProps="{ type: 'number' }" -->
					<span style="padding-left: 10px">m/s</span>
				</sf-group-wrapper>
			</el-col>
			<el-col :span="8">
				<sf-group-wrapper class="checkbox-form" :label="getMessage_('SWCC000293')" labelPosition="left" :gutter="30" :labelSpan="15">
					<sf-input-group :inputValue="selectedRow.regReadTime" :onChange="value => onChange({ key: 'regReadTime', value })" />
					<!-- :elProps="{ type: 'number' }" -->
					<span style="padding-left: 10px">m/s</span>
				</sf-group-wrapper>
			</el-col>
			<el-col :span="8">
				<sf-group-wrapper class="checkbox-form" :label="getMessage_('SWCC000294')" labelPosition="left" :gutter="30" :labelSpan="15">
					<sf-input-group :inputValue="selectedRow.procStatUpTime" :onChange="value => onChange({ key: 'procStatUpTime', value })" />
					<!-- :elProps="{ type: 'number' }" -->
					<span style="padding-left: 10px">m/s</span>
				</sf-group-wrapper>
			</el-col>
		</el-row>
		<!-- DQWait Time & Reg Read Time & Status Update Time End -->

		<!-- Error Logging Time & Pooling Time & DB Recon Time Start -->
		<el-row :gutter="30" style="display: flex; align-items: center">
			<el-col :span="8">
				<sf-group-wrapper class="checkbox-form" :label="getMessage_('SWCC000296')" labelPosition="left" :gutter="30" :labelSpan="15">
					<sf-input-group :inputValue="selectedRow.errMsgLoggingTime" :onChange="value => onChange({ key: 'errMsgLoggingTime', value })" />
					<!-- :elProps="{ type: 'number' }" -->
					<span style="padding-left: 10px">m/s</span>
				</sf-group-wrapper>
			</el-col>
			<el-col :span="8">
				<sf-group-wrapper class="checkbox-form" :label="getMessage_('SWCC000297')" labelPosition="left" :gutter="30" :labelSpan="15">
					<sf-input-group :inputValue="selectedRow.poolTime" :onChange="value => onChange({ key: 'poolTime', value })" />
					<!-- :elProps="{ type: 'number' }" -->
					<span style="padding-left: 10px">m/s</span>
				</sf-group-wrapper>
			</el-col>
			<el-col :span="8">
				<sf-group-wrapper class="checkbox-form" :label="getMessage_('SWCC000298')" labelPosition="left" :gutter="30" :labelSpan="15">
					<sf-input-group :inputValue="selectedRow.dbReconTime" :onChange="value => onChange({ key: 'dbReconTime', value })" />
					<!-- :elProps="{ type: 'number' }" -->
					<span style="padding-left: 10px">m/s</span>
				</sf-group-wrapper>
			</el-col>
		</el-row>
		<!-- Error Logging Time & Pooling Time & DB Recon Time End -->

		<!-- Socket Recon Time & Rep Flg & Logic Trck Flg Start -->
		<el-row :gutter="30" style="display: flex; align-items: center">
			<el-col :span="8">
				<sf-group-wrapper class="checkbox-form" :label="getMessage_('SWCC000299')" labelPosition="left" :gutter="30" :labelSpan="15">
					<sf-input-group :inputValue="selectedRow.socketReconTime" :onChange="value => onChange({ key: 'socketReconTime', value })" />
					<!-- :elProps="{ type: 'number' }" -->
					<span style="padding-left: 10px">m/s</span>
				</sf-group-wrapper>
			</el-col>
			<el-col :span="8">
				<sf-group-wrapper class="checkbox-form" :label="getMessage_('SWCC000300')" labelPosition="left" :gutter="30" :labelSpan="15">
					<el-checkbox
						:value="selectedRow.rptProcFlg === 'Y'"
						@change="value => onChange({ key: 'rptProcFlg', value: value === true ? 'Y' : 'N' })"
					/>
				</sf-group-wrapper>
			</el-col>
			<el-col :span="8">
				<sf-group-wrapper class="checkbox-form" :label="getMessage_('SWCC000301')" labelPosition="left" :gutter="30" :labelSpan="15">
					<el-checkbox
						:value="selectedRow.logicTrkFlg === 'Y'"
						@change="value => onChange({ key: 'logicTrkFlg', value: value === true ? 'Y' : 'N' })"
					/>
				</sf-group-wrapper>
			</el-col>
		</el-row>
		<!-- Socket Recon Time & Rep Flg & Logic Trck Flg End -->

		<!-- MonitorCfg Start -->
		<el-row :gutter="30">
			<div class="contour">MonitorCfg</div>
		</el-row>
		<!-- MonitorCfg End -->

		<!-- PLCSvrIp & PLCSvrIPBU & PLCSvrPort Start -->
		<el-row :gutter="30" style="display: flex; align-items: center">
			<el-col :span="8">
				<sf-group-wrapper class="checkbox-form" :label="getMessage_('SWCC000303')" labelPosition="left" :gutter="30" :labelSpan="15">
					<sf-input-group :inputValue="selectedRow.plcSvrIp" :onChange="value => onChange({ key: 'plcSvrIp', value })" />
					<!-- :elProps="{ type: 'number' }" -->
				</sf-group-wrapper>
			</el-col>
			<el-col :span="8">
				<sf-group-wrapper class="checkbox-form" :label="getMessage_('SWCC000304')" labelPosition="left" :gutter="30" :labelSpan="15">
					<sf-input-group :inputValue="selectedRow.plcSvrIpB" :onChange="value => onChange({ key: 'plcSvrIpB', value })" />
				</sf-group-wrapper>
			</el-col>
			<el-col :span="8">
				<sf-group-wrapper class="checkbox-form" :label="getMessage_('SWCC000305')" labelPosition="left" :gutter="30" :labelSpan="15">
					<sf-input-group :inputValue="selectedRow.plcSvrPort" :onChange="value => onChange({ key: 'plcSvrPort', value })" />
				</sf-group-wrapper>
			</el-col>
		</el-row>
		<!-- PLCSvrIp & PLCSvrIPBU & PLCSvrPort End -->

		<!-- AutoPgmMain & AutoPgmBack & StandbyChgTm Start -->
		<el-row :gutter="30" style="display: flex; align-items: center">
			<el-col :span="8">
				<sf-group-wrapper class="checkbox-form" :label="getMessage_('SWCC000306')" labelPosition="left" :gutter="30" :labelSpan="15">
					<sf-input-group :inputValue="selectedRow.autoPgmMain" :onChange="value => onChange({ key: 'autoPgmMain', value })" />
				</sf-group-wrapper>
			</el-col>
			<el-col :span="8">
				<sf-group-wrapper class="checkbox-form" :label="getMessage_('SWCC000307')" labelPosition="left" :gutter="30" :labelSpan="15">
					<sf-input-group :inputValue="selectedRow.autoPgmBack" :onChange="value => onChange({ key: 'autoPgmBack', value })" />
				</sf-group-wrapper>
			</el-col>
			<el-col :span="8">
				<sf-group-wrapper class="checkbox-form" :label="getMessage_('SWCC000308')" labelPosition="left" :gutter="30" :labelSpan="15">
					<sf-input-group
						:inputValue="selectedRow.standbyChgTime"
						:onChange="value => onChange({ key: 'standbyChgTime', value })"
						:elProps="{ type: 'number' }"
					/>
					<span style="padding-left: 10px">m/s</span>
				</sf-group-wrapper>
			</el-col>
		</el-row>
		<!-- AutoPgmMain & AutoPgmBack & StandbyChgTm End -->

		<!-- ProcKind & Monitoring & Process Modeling Start -->
		<el-row :gutter="30" style="display: flex; align-items: center">
			<el-col :span="8">
				<sf-group-wrapper class="checkbox-form" :label="getMessage_('SWCC000309')" labelPosition="left" :gutter="30" :labelSpan="15">
					<sf-select-group
						label=""
						:labelSpan="0"
						labelPosition="left"
						:inputValue="selectedRow.procKind"
						:options="procKinds_.filter(option => option.label !== 'ALL')"
						:onChange="value => onChange({ key: 'procKind', value })"
					/>
				</sf-group-wrapper>
			</el-col>
			<el-col :span="8">
				<sf-group-wrapper class="checkbox-form" :label="getMessage_('SWCC000295')" labelPosition="left" :gutter="30" :labelSpan="15">
					<el-checkbox
						:value="selectedRow.stateMonFlg === '1'"
						@change="value => onChange({ key: 'stateMonFlg', value: value ? '1' : '0' })"
					/>
				</sf-group-wrapper>
			</el-col>
			<el-col :span="8">
				<sf-group-wrapper class="checkbox-form" :label="getMessage_('SWCC000313')" labelPosition="left" :gutter="30" :labelSpan="15">
					<el-checkbox
						:value="selectedRow.autoPgmMain === 'SFaaS.COM.CC.TM.CP03.C.PT.dll' && selectedRow.autoPgmBack === 'SFaaS.COM.CC.TM.CP03.C.PT'"
						@input="
							value => {
								onChange({ key: 'autoPgmMain', value: value ? 'SFaaS.COM.CC.TM.CP03.C.PT.dll' : '' });
								onChange({ key: 'autoPgmBack', value: value ? 'SFaaS.COM.CC.TM.CP03.C.PT' : '' });
							}
						"
					/>
				</sf-group-wrapper>
			</el-col>
		</el-row>
		<!-- ProcKind & Monitoring & Process Modeling End -->

		<template v-slot:footer>
			<sf-button
				v-if="isButton_(scrId, 'CD')"
				v-show="disabled"
				line
				color="error"
				type="primary"
				:onClick="
					() =>
						$sf_showMessage({
							type: 'confirm',
							icon: 'confirm',
							message: getMessage_('SWCC000554'),
							buttons: [{ title: getMessage_('SWCC000280'), clickFn: removeProcess }]
						})
				"
				>{{ getMessage_('SWCC000280') }}</sf-button
			>
			<sf-button line :onClick="closeModal">{{ getMessage_('SWCC000243') }}</sf-button>
			<sf-button
				v-if="isButton_(scrId, 'AD')"
				v-show="!disabled"
				type="primary"
				:onClick="
					() =>
						$sf_showMessage({
							type: 'confirm',
							icon: 'confirm',
							message: getMessage_('SWCC000555'),
							buttons: [{ title: getMessage_('SWCC000245'), clickFn: registerProcess }]
						})
				"
				>{{ getMessage_('SWCC000245') }}</sf-button
			>
			<sf-button
				v-if="isButton_(scrId, 'AD')"
				v-show="disabled"
				type="primary"
				:onClick="
					() =>
						$sf_showMessage({
							type: 'confirm',
							icon: 'confirm',
							message: getMessage_('SWCC000553'),
							buttons: [{ title: getMessage_('SWCC000279'), clickFn: modifyProcess }]
						})
				"
				>{{ getMessage_('SWCC000279') }}</sf-button
			>
		</template>
	</sf-modal-layout>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@common/ProcessRegistration/store/helpers';
import * as yup from 'yup';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		closeModal() {
			this.DEFAULT_ASSIGN({
				key: 'popupParams',
				value: {
					type: '',
					show: false,
					selectedRow: {}
				}
			});
		},
		onChange({ key, value }) {
			this.DEFAULT_ASSIGN({
				key: 'popupParams',
				value: {
					...this.popupParams,
					selectedRow: {
						...this.selectedRow,
						[key]: value
					}
				}
			});
		},
		registerProcess() {
			try {
				this.schema.validateSync(this.selectedRow);

				this.$sf_toggleLoading(true);
				this.createProcess_({ process: this.selectedRow })
					.then(header => {
						this.$sf_toast({
							...this.$sf_setToastOption(header),
							message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
						});
					})
					.catch(error => {
						this.$sf_toast({ type: 'error', message: error.message });
					})
					.then(() => this.fetchProcesses_({ plantCd: this.user.plantCd, urlSearchParams: this.urlSearchParams_ }))
					.then(this.closeModal)
					.finally(() => this.$sf_toggleLoading(false));
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			}
		},
		modifyProcess() {
			try {
				this.schema.validateSync(this.selectedRow);

				this.$sf_toggleLoading(true);
				this.updateProcess_({ process: this.selectedRow })
					.then(header => {
						this.$sf_toast({
							...this.$sf_setToastOption(header),
							message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
						});
					})
					.catch(error => {
						this.$sf_toast({ type: 'error', message: error.message });
					})
					.then(() => this.fetchProcesses_({ plantCd: this.user.plantCd, urlSearchParams: this.urlSearchParams_ }))
					.then(this.closeModal)
					.finally(() => this.$sf_toggleLoading(false));
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			}
		},
		removeProcess() {
			try {
				this.$sf_toggleLoading(true);
				this.deleteProcess_({ process: this.selectedRow })
					.then(header => {
						this.$sf_toast({
							...this.$sf_setToastOption(header),
							message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
						});
					})
					.catch(error => {
						this.$sf_toast({ type: 'error', message: error.message });
					})
					.then(() => this.fetchProcesses_({ plantCd: this.user.plantCd, urlSearchParams: this.urlSearchParams_ }))
					.then(this.closeModal)
					.finally(() => this.$sf_toggleLoading(false));
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			}
		}
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		selectedRow() {
			const { selectedRow } = this.popupParams;
			return selectedRow;
		},
		disabled() {
			const { type } = this.popupParams;
			return type.includes('update');
		},
		schema() {
			return yup.object().shape({
				procId: yup.string().nullable().required(this.getMessage_('SWCC000500')),
				plantCd: yup.string().nullable().required(this.getMessage_('SWCC000805')),
				procName: yup
					.string()
					.trim()
					.default('')
					.max(
						100,
						this.$sf_formatString(this.getMessage_('SWCC000177') /**{0}은 최대 {1} 자리까지 입력 가능합니다. */, [
							this.getMessage_('SWCC000582'),
							100
						])
					),
				procPara: yup
					.string()
					.nullable()
					.trim()
					.default('')
					.max(
						200,
						this.$sf_formatString(this.getMessage_('SWCC000177') /**{0}은 최대 {1} 자리까지 입력 가능합니다. */, [
							this.getMessage_('SWCC000291'),
							200
						])
					),
				dqWaitTime: yup
					.number()
					.typeError(this.$sf_formatString(this.getMessage_('SWCC000895'), [this.getMessage_('SWCC000292')]))
					.nullable(),
				regReadTime: yup
					.number()
					.typeError(this.$sf_formatString(this.getMessage_('SWCC000895'), [this.getMessage_('SWCC000293')]))
					.nullable(),
				procStatUpTime: yup
					.number()
					.typeError(this.$sf_formatString(this.getMessage_('SWCC000895'), [this.getMessage_('SWCC000294')]))
					.nullable(),
				errMsgLoggingTime: yup
					.number()
					.typeError(this.$sf_formatString(this.getMessage_('SWCC000895'), [this.getMessage_('SWCC000296')]))
					.nullable(),
				poolTime: yup
					.number()
					.typeError(this.$sf_formatString(this.getMessage_('SWCC000895'), [this.getMessage_('SWCC000297')]))
					.nullable(),
				dbReconTime: yup
					.number()
					.typeError(this.$sf_formatString(this.getMessage_('SWCC000895'), [this.getMessage_('SWCC000298')]))
					.nullable(),
				socketReconTime: yup
					.number()
					.typeError(this.$sf_formatString(this.getMessage_('SWCC000895'), [this.getMessage_('SWCC000299')]))
					.nullable(),
				plcSvrIp: yup
					.string()
					.nullable()
					.trim()
					.default('')
					.max(
						20,
						this.$sf_formatString(this.getMessage_('SWCC000177') /**{0}은 최대 {1} 자리까지 입력 가능합니다. */, [
							this.getMessage_('SWCC000303'),
							20
						])
					),
				plcSvrIpB: yup
					.string()
					.nullable()
					.trim()
					.default('')
					.max(
						20,
						this.$sf_formatString(this.getMessage_('SWCC000177') /**{0}은 최대 {1} 자리까지 입력 가능합니다. */, [
							this.getMessage_('SWCC000304'),
							20
						])
					),
				plcSvrPort: yup
					.number()
					.nullable()
					.max(
						5,
						this.$sf_formatString(this.getMessage_('SWCC000177') /**{0}은 최대 {1} 자리까지 입력 가능합니다. */, [
							this.getMessage_('SWCC000305'),
							5
						])
					),
				autoPgmMain: yup
					.string()
					.nullable()
					.trim()
					.default('')
					.max(
						50,
						this.$sf_formatString(this.getMessage_('SWCC000177') /**{0}은 최대 {1} 자리까지 입력 가능합니다. */, [
							this.getMessage_('SWCC000306'),
							50
						])
					),
				autoPgmBack: yup
					.string()
					.nullable()
					.trim()
					.default('')
					.max(
						50,
						this.$sf_formatString(this.getMessage_('SWCC000177') /**{0}은 최대 {1} 자리까지 입력 가능합니다. */, [
							this.getMessage_('SWCC000307'),
							50
						])
					),
				standbyChgTime: yup.number().typeError(this.$sf_formatString(this.getMessage_('SWCC000895'), [this.getMessage_('SWCC000308')]))
			});
		}
	}
};
</script>

<style lang="scss">
.process-registration {
	.el-form-item__label {
		font-weight: bold;
		color: #111111;
		font-size: 14px;
	}

	.contour {
		width: 100%;
		height: 38px;
		background-color: #dedede;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #111111;
		font-size: 14px;
		font-family: HyundaiSansHead;
		font-weight: 500;
	}

	// TODO:
	.checkbox-form {
		.el-row {
			.el-col-24 {
				display: flex;
				align-items: center;
				padding-left: 0px !important;
			}
		}
	}
}
</style>
